export { DMS_MODULE } from '../constants';
export const NAME = 'PredmetPujcovna';
export const CRUMB_LABEL_KEY = 'edtOstatnipa';
